import './MyTeamPage.scss';
import React, { useEffect, useState }  from 'react';
import { getUserTeam, saveConfig, getFantasyConfig } from '../../firebase-service/firebaseService.js'
import { useAuth } from '../../context/authContext'
import { toast } from 'sonner'
import PlayerCard from '../../component/PlayerCard.js';
import PlayerCardImage from '../../component/PlayerCardImage.js';

export function MyTeamPage() {

    const [equipoUsuario, setEquipoUsuario] = useState([]);
    const [equipoUsuarioAnterior, setEquipoUsuarioAnterior] = useState([]);
    const [configJornadaAnterior, setConfigJornadaAnterior] = useState({capitan:"",sextoHombre:""});
    const [canSave, setCanSave] = useState(false);
    const [config, setConfig] = useState({capitan:"",sextoHombre:""});
    const [cambiandoCapitan, setCambiandoCapitan] = useState(false);
    const [cambiandoSextoHombre, setCambiandoSextoHombre] = useState(false);
    const [jugadorTempIndex, setJugadorTempIndex] = useState(0);
    const [jornada, setJornada] = useState(0);
    const [jornadaSeleccionada, setJornadaSeleccionada] = useState(0);
    const [cambiosAbiertos, setCambiosAbiertos] = useState(true);

    const [isCapitanOk, setIsCapitanOk] = useState(true);

    const { currentUser, actualParticipante } = useAuth()

    useEffect(() => {
        esperarPorFantasyConfig()
    }, []);

    const esperarPorJugadoresUsuario = async (jornada) => {
        getUserTeam(currentUser.uid, jornada, resp => {
            console.log(jornada)
            if (resp.length > 1) { 
                setConfig(resp[0])
                const respOrd = resp.sort((a, b) => {
                    const aEsObjetivo = a.nombre === resp[0].sextoHombre;
                    const bEsObjetivo = b.nombre === resp[0].sextoHombre;

                    if (aEsObjetivo && !bEsObjetivo) return 1;
                    if (!aEsObjetivo && bEsObjetivo) return -1;
                    return 0;
                    });
                setEquipoUsuario(respOrd)
            }
            if (resp.length <= 1) { setEquipoUsuario([]) }
        }, (resp, err) => { console.error(resp, err) })
    };

    const esperarPorConfigJornadaAnterior = async (jornada) => {
        if (jornada != 0) {
            getUserTeam(currentUser.uid, jornada - 1, resp => {
                if (resp.length > 1) {
                    setConfigJornadaAnterior(resp[0])
                    setEquipoUsuarioAnterior(resp)
                }
                if (resp.length <= 1) {
                    setConfigJornadaAnterior({capitan:"",sextoHombre:""});
                    setEquipoUsuarioAnterior([])
                }
            }, (resp, err) => { console.error(resp, err) })
        }
    };

    const esperarPorFantasyConfig = async () => {
        getFantasyConfig(resp => {
            if (resp != null) { 
                setJornada(resp.nJornada)
                setJornadaSeleccionada(resp.nJornada)
                setCambiosAbiertos(resp.cambiosAbiertos)
                esperarPorJugadoresUsuario(resp.nJornada)
                esperarPorConfigJornadaAnterior(resp.nJornada)
            }
            if (resp === null) { setJornada(0); setCambiosAbiertos(true) }
        }, (resp, err) => { console.error(resp, err) })
    };

    const esMismoEquipoQueAnterior = () => {
        if (!equipoUsuarioAnterior || equipoUsuarioAnterior.length <= 1) return false;

        const equiposActuales = equipoUsuario
            .filter((_, index) => index !== 0)
            .map((jugador) => jugador.nombre)
            .sort();
        const equiposAnteriores = equipoUsuarioAnterior
            .filter((_, index) => index !== 0)
            .map((jugador) => jugador.nombre)
            .sort();

            console.log("equiposActuales", equiposActuales);
            console.log("equiposAnteriores", equiposAnteriores);

        return equiposActuales.length === equiposAnteriores.length &&
            equiposActuales.every((nombre, index) => nombre === equiposAnteriores[index]);
    };

    const getEquipoNoValidoMensaje = () => {
        if (esMismoEquipoQueAnterior()) {
            return 'El equipo no es válido: no puedes repetir exactamente el mismo equipo que la jornada anterior';
        }

        if (config.capitan === configJornadaAnterior.capitan && configJornadaAnterior.capitan) {
            return 'El equipo no es válido: no puedes repetir el mismo capitán que la jornada anterior';
        }

        return '';
    };

    const handleSetCapitan = () =>{
        setCambiandoCapitan(true)
        setJugadorTempIndex(equipoUsuario.findIndex(u => u.nombre === config.capitan))
        setConfig({capitan:"",sextoHombre:config.sextoHombre})
    }

    const handleSetSextoHombre= () =>{
        setCambiandoSextoHombre(true)
        setConfig({capitan:config.capitan,sextoHombre:""})
    }

    const handleSetPlayerAs =(index) => {
        
        if(cambiandoCapitan){
            if(equipoUsuario[index].nombre == configJornadaAnterior.capitan){
                toast.error('No puedes poner como capitán al mismo jugador de la jornada anterior')
                setConfig({capitan:equipoUsuario[jugadorTempIndex].nombre,sextoHombre:config.sextoHombre})
                return
            }

            if(equipoUsuario[index].nombre != config.sextoHombre){
                setConfig({capitan:equipoUsuario[index].nombre,sextoHombre:config.sextoHombre})
                setCanSave(true)
            } else {
                setConfig({capitan:equipoUsuario[index].nombre,sextoHombre:equipoUsuario[jugadorTempIndex].nombre})
                setCanSave(true)
                setEquipoUsuario(intercambiarElementos(equipoUsuario,equipoUsuario[jugadorTempIndex],equipoUsuario[6]))
            }
        } if (cambiandoSextoHombre) {
            if(equipoUsuario[index].nombre != config.capitan){
                setConfig({capitan:config.capitan,sextoHombre:equipoUsuario[index].nombre})
                setCanSave(true)
                setEquipoUsuario(intercambiarElementos(equipoUsuario,equipoUsuario[index],equipoUsuario[6]))
            } else {
                if(equipoUsuario[6].nombre != configJornadaAnterior.capitan){
                    setConfig({capitan:equipoUsuario[6].nombre,sextoHombre:equipoUsuario[index].nombre})
                    setCanSave(true)
                    setEquipoUsuario(intercambiarElementos(equipoUsuario,equipoUsuario[index],equipoUsuario[6]))
                } else {
                    setConfig({capitan:equipoUsuario[index].nombre,sextoHombre:equipoUsuario[6].nombre})
                }
            }
        }
        setCambiandoSextoHombre(false)
        setCambiandoCapitan(false)
    }

    function intercambiarElementos(arr, objA, objB) {
        const indexA = arr.indexOf(objA);
        const indexB = arr.indexOf(objB);

        if (indexA === -1 || indexB === -1) {
            console.warn('Uno de los objetos no está en el array');
            return arr;
        }

        [arr[indexA], arr[indexB]] = [arr[indexB], arr[indexA]];
        return arr;
    }

    const handleSaveConfig = async (config) =>{
        if (config.capitan === configJornadaAnterior.capitan && configJornadaAnterior.capitan) {
            toast.error('No puedes guardar el mismo capitán que la jornada anterior')
            return
        }

        if (esMismoEquipoQueAnterior()) {
            toast.error('No puedes guardar el mismo equipo que la jornada pasada')
            return
        }

        try {
            await saveConfig(currentUser.uid,config, jornada)
            toast.success('Capitán y sexto hombre guardados')
            setCanSave(false)
        } catch (err) {
            toast.error('No se pudo guardar. Inténtalo de nuevo')
        }
    }

    const getJornadasConPuntos = () =>{
        let content = [];
        for (let i = 0; i < jornada; i++) {
            //Jornadas aplazadas ejemplo 30
            if(i <= 28){
                content.push(
                    <div key={"jornada"+ i + actualParticipante.nombre} className={jornadaSeleccionada - 1 == i ? "jornada-circulo-selected" : "jornada-circulo"} onClick={() => seleccionarJornada(i + 1)}>
                        <div className='jornada-numero'>{"J"+(i + 1)}</div>
                        <div className='jornada-puntos'>{actualParticipante.puntosJornada[i] != null ? actualParticipante.puntosJornada[i] : "-"}</div>
                    </div>);
            } else if (i == 29){
                content.push(
                    <div key={"jornada"+ i + actualParticipante.nombre} className={jornadaSeleccionada - 1 == i ? "jornada-circulo-selected" : "jornada-circulo"} onClick={() => seleccionarJornada(i + 1)}>
                        <div className='jornada-numero'>{"J"+(i + 1)}</div>
                        <div className='jornada-puntos'>{"-"}</div>
                    </div>);
            } else if (i >= 30){
                content.push(
                    <div key={"jornada"+ i + actualParticipante.nombre} className={jornadaSeleccionada - 1 == i ? "jornada-circulo-selected" : "jornada-circulo"} onClick={() => seleccionarJornada(i + 1)}>
                        <div className='jornada-numero'>{"J"+(i + 1)}</div>
                        <div className='jornada-puntos'>{actualParticipante.puntosJornada[i-1] != null ? actualParticipante.puntosJornada[i-1] : "-"}</div>
                    </div>);
            } else {
                 content.push(
                    <div key={"jornada"+ i + actualParticipante.nombre} className={jornadaSeleccionada - 1 == i ? "jornada-circulo-selected" : "jornada-circulo"} onClick={() => seleccionarJornada(i + 1)}>
                        <div className='jornada-numero'>{"J"+(i + 1)}</div>
                        <div className='jornada-puntos'>{actualParticipante.puntosJornada[i] != null ? actualParticipante.puntosJornada[i] : "-"}</div>
                    </div>);
            }
        }
        return content;
    }

    const seleccionarJornada = (nJornada) =>{
        setJornadaSeleccionada(nJornada)
        esperarPorJugadoresUsuario(nJornada)
        esperarPorConfigJornadaAnterior(nJornada)
    }

    return (
        <main className="my-team-container">
            <div className='jornadas-container'>
                {getJornadasConPuntos()}
            </div>
            {/*false && <div className='team-container'>   ANTIGUO
                {equipoUsuario.map((jugador, index) => {
                    if(index != 0){
                        return <PlayerCard key={index} config={config} index={index} jugador={jugador} updateSelections={()=>handleSetPlayerAs(index)} longPressActive={false} openDetails={()=>{}}/> 
                    }
                })}
            </div>*/}
            {true && <div className='team-container-image'>
                {true && equipoUsuario.map((jugador, index) => {
                    if(index != 0){
                        return (
                            <div className={"position"+index}>
                                <PlayerCardImage key={index} config={config} index={index} jugador={jugador} updateSelections={()=>handleSetPlayerAs(index)} longPressActive={false} openDetails={()=>{}} jornadaSeleccionada={jornadaSeleccionada} jornadaActual={jornada}/>
                            </div>
                        )
                    }
                })}
            </div>}
            {cambiosAbiertos && jornadaSeleccionada == jornada && 
            <div className='buttons-action-container'>
                <div className='capitan-button' onClick={()=>handleSetCapitan()}>
                    {cambiandoCapitan ? "Seleccionar un nuevo capitán" : "Cambiar capitán"}
                </div>
                <div className='sextoHombre-button' onClick={()=>handleSetSextoHombre()}>
                    {cambiandoSextoHombre ? "Seleccionar un nuevo sexto hombre" : "Cambiar 6º hombre"}
                    
                </div>
            </div>
            }
            {(!cambiosAbiertos || jornadaSeleccionada != jornada) && 
            <div className='buttons-action-container'>
                <div className='capitan-button-disabled'>
                    {cambiandoCapitan ? "Seleccionar un nuevo capitán" : "Cambiar capitán"}
                </div>
                <div className='sextoHombre-button-disabled'>
                    {cambiandoSextoHombre ? "Seleccionar un nuevo sexto hombre" : "Cambiar 6º hombre"}
                    
                </div>
            </div>
            }
            {getEquipoNoValidoMensaje() &&
                <div className='team-invalid-message'>
                    {getEquipoNoValidoMensaje()}
                </div>
            }
            {canSave &&
                <div className='bottom-container' >
                    <div className='button-container' onClick={()=>handleSaveConfig(config)}>
                        <div className='save-button'>
                            Guardar
                        </div>
                    </div>
                </div>
            }
        </main>
    );
}